import {lazy} from 'react';

export const RteReadMoreLazy = lazy(() => import(/* webpackChunkName: "rteReadMore" */ '.'));
